<template>
  <div>
    <div class="cont" style="">
      <div style="position:fixed;top: 0;width:100%;z-index:999;">
        <div id="header">
          <div id="goind" @click="refresh">
          </div>
          <h3>趣美妆</h3>
          <span v-show="!isLogin" id="tomin" class="tomin " tag="div" @click="zhangh"></span>
          <div v-show="isLogin" id="user" class="user" tag="div" @click="userCenter">
              <img :src="headUrl"  alt="" style="padding: 0;width:100%;height: 100%;" >
          </div>
        </div>
      </div>

      <div id="vm" class="pubu" v-cloak>
        <div :id="nav_id" style="margin-top:.45rem;margin-bottom:.1rem;overflow: hidden;">
          <div>
            <!-- <img src="../../static/img/247.png" style="width:100%;height:100%;" alt=""> -->
          </div>
        </div>
        <ul id="show" class="yg yg_l" >
          <a @click="goToDetail(item.id)" style="position:relative;" tag="li"
                       v-for="(item,index) in dataList" :key="item.index" v-if="index%2==0">
            <div style="width:100%;overflow:hidden;" class="note-item">
              <img :src="item.src1" :id="item.id" alt="" style="padding: 0">
              <div class="note-content">
                <h3 class="note-title">{{ item.title }}</h3>
              </div>
              <div class="img-de">
                <div style="line-height:.17rem;">
                  <img :src="item.headUrl" style="width:.17rem;height:.17rem;border-radius:.17rem;" alt="">
                </div>
                <div class="note-nick">
                  {{ item.nickName }}
                </div>
                <div style="text-align:end;font-size:.12rem;color:#adadad;width: 1.66rem;">
                  <img src="../../static/img/kongxin.png" style="width:.12rem;" alt="" v-show="item.ifLike === '0'">
                  <img src="../../static/img/shixin.png" style="width:.12rem;" alt="" v-show="item.ifLike === '1'">
                  {{ item.like }}
                </div>
              </div>
            </div>
          </a>
        </ul>
        <ul class="yg yg_r">
          <a @click="goToDetail(item.id)" style="position:relative;" tag="li"
                       v-for="(item,index) in dataList" :key="item.index" v-if="index%2==1">
            <div style="width:100%;overflow:hidden;" class="note-item">
              <img :src="item.src1" :id="item.id" alt="" style="padding: 0">
              <div class="note-content">
                <h3 class="note-title">{{ item.title }}</h3>
              </div>
              <div class="img-de">
                <div style="line-height:.17rem;">
                  <img :src="item.headUrl" style="width:.17rem;height:.17rem;border-radius:.17rem;" alt="">
                </div>
                <div class="note-nick">
                  {{ item.nickName }}
                </div>
                <div style="text-align:end;font-size:.12rem;color:#adadad;width: 1.66rem;">
                  <img src="../../static/img/kongxin.png" style="width:.12rem;" alt="" v-show="item.ifLike === '0'">
                  <img src="../../static/img/shixin.png" style="width:.12rem;" alt="" v-show="item.ifLike === '1'">
                  {{ item.like }}
                </div>
              </div>
            </div>
          </a>
        </ul>

        <div style="clear: both;"></div>
        <div style="margin:.1rem auto;text-align:center;font-size:.12rem;color:#999;" v-show="load">{{ loading }}</div>
        <div id="onmore" @click="upCallback1()" style="">
          查看更多
        </div>
        <div :id="nav_bottom_id" style="margin-top: .1rem;margin-bottom:.1rem;overflow: hidden;">
          <div>
            <!-- <img src="../../static/img/247.png" style="width:100%;height:100%;" alt=""> -->
          </div>
        </div>
        <div id="foot">
          <p style="color:white;padding: 0 .1rem;">声明：本站提供的图片等资源素材来自投稿以及收集于互联网，如果侵犯了您的版权请来信告知，我们会及时处理和回复。</p>
          Copyright © 2022-2025 中广在线(北京)网络科技有限公司 All Rights Reserved.网站备案/许可证号:
          <a href="https://beian.miit.gov.cn" target="_blank" style="color:#fff;">京ICP备19011357号-3</a>
          <p style="text-align: center;">
            <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010602006775" style="color: #fff;">
              <img data-v-2d7e8ae2="" src="/static/img/BeianIcon.png" alt="" style="width: 24px; height: 24px;">
              京公网安备 11010602006775号
            </a>
          </p>
        </div>
      </div>

      <div @click="Desk"  style="position:fixed;bottom:0.8rem;right:0.1rem;width:.4rem;height:.4rem;opacity:.92;">
        <!-- 添加桌面 -->
        <img src="../../static/img/addsc.png" style="width:.4rem;height:.4rem;" alt="">
      </div>
      <div id="totop"  @click="totop" style="position:fixed;bottom:0.4rem;right:0.05rem;width:.3rem;height:.32rem;opacity:.92;">
        <img src="../../static/img/12.png" style="width:80%;" alt="">
      </div>
    </div>
    <div  id="tishi" v-show="addDesk">
      <div id="logo">
        <!-- <img src="../../static/img/qv_logo.png" alt=""> -->
      </div>
      <div style="position:fixed;width:2rem;">
        <p style="font-size:.12rem;margin-left: .03rem;">点击<img style="width: .1rem;margin: 0 .04rem;" src="../../static/img/sha.png" alt="">选择“<span
            style="color:#d02121;">添加书签</span>”,“<span style="color:#d02121;">添加桌面</span>”放至手机主屏。</p>
      </div>
    </div>
  </div>
</template>

<script>
import {setTimeout, clearInterval} from 'timers';
import Cookies from 'js-cookie';
export default {
  name: 'BeautyList',
  data() {
    return {
      name:'BeautyList',
      mescroll: null, //mescroll实例对象
      dataList: [], //列表数据
      huo: [],
      addDesk: false,
      loading: '加载中...',
      num: 1,
      load: false,
      headUrl:'',
      userId:'',
      nickName:'',
      src:'',
      src_id:'',
      isLogin:false,
      fromWeather:false,
      nav_id:'_' + this.common.randomStringForId(Math.random() * 8 + 12),
      nav_bottom_id:'_' + this.common.randomStringForId(Math.random() * 8 + 12),
    }
  },
  beforeRouteLeave(to,from,next){
    //离开页面之前将高度存储到sessionStorage。这里不建议用localStorage，因为session在关闭浏览器时会自动清除，而local则需要手动清除，有点麻烦。
    this.userTool.setBHeight(document.body.scrollTop)
    next()
  },
  methods: {
    goToDetail:function (id){
      this.$router.push({name: 'BeautyDetail', query: {id: id}});
    },
    initSrc:function(){
      if(this.$route.query.id){
        this.src_id =  this.$route.query.id;
      }
      if(this.$route.query.src){
        this.src = this.common.decodePath(this.$route.query.src)
      }
    },
    zhangh: function () {
      let path = this.common.encodePath("BeautyList");
      this.$router.push({name: 'Login', query: {src: path}});
    },
    userCenter: function () {
      let path = this.common.encodePath("BeautyList");
      this.$router.push({name: 'vip', query: {src: path}});
    },
    randomString: function(len) {
      len = len || 4;
      var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
      /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
      var maxPos = $chars.length;
      var pwd = '';
      for (var i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    getCookie: function () {
      // Cookies.remove("book_huoqu");
      this.uuid = this.common.getUUID();
      this.userId = this.userTool.getUserId();
      this.headUrl = this.userTool.getUserHeadUrl();
      if (this.userId == undefined || this.userId == '') {
        this.isLogin = false;
      } else {
        this.isLogin = true;
      }
    },
    Desk: function () {
      this.addDesk = !this.addDesk;
      let that = this;
      setTimeout(function () {
        that.addDesk = false;
      }, 2000)
    },
    totop() {
      $("body").animate({
        scrollTop: "0px"
      })
    },
    isad: function () {
      if ($('div[id=e_b_div_113]').length != 0) {
        // console.log($('div[id=e_b_div_1]'));
        // console.log(1);
        $(".cont").css('padding-top', "1.6rem");
      } else {
        // console.log(0);
        $(".cont").css('padding-top', "0.1rem");
      }
    },
    upCallback1: function () {
      let that = this;
      // console.log(that.num);
      that.load = true;
      that.num = that.num + 1;
      var page = {num: that.num, size: 10};
      // console.log(page);
      that.upCallback(page);
    },
    //上拉回调 page = {num:1, size:10}; num:当前页 ,默认从1开始; size:每页数据条数,默认10
    upCallback(page) {
      //联网请求
      // console.log(page);
      let that = this;
      let uuid = this.common.getUUID();
      let userId = this.userTool.getUserId();

      let params = {
        "userId": userId,
        "uuid": uuid,
        "type": 2,
        "pageSize": page.size,
        "pageNo": page.num
      };

      let t = new Date().getTime();

      let jiami = this.common.encodeParams(params,t);

      let apiUrl = process.env.APP_API_URL;

      // console.log(source);
      this.$http.get(apiUrl + "/note/list?data=" + jiami + "&t=" + t,
      ).then((response) => {
        // console.log(response);
        if (response.body.data == null) {
          this.loading = '已加载全部';
          this.load = true;
          $("#onmore").attr('style', 'display:none;');
        } else {
          this.load = false;
        }
        //请求的列表数据
        let arr = response.body.data.noteList;

        for (let i in arr) {
          this.dataList.push({
            src1: arr[i].coverUrl,
            headUrl: arr[i].headUrl,
            id: arr[i].id,
            like: ' ' + arr[i].totalLike,
            title: arr[i].title,
            nickName: arr[i].nickName,
            ifLike:arr[i].like == null ? '0' : '' + arr[i].like
          })
        }
        var book_huoqu = Cookies.get("book_huoqu");
        // console.log(book_huoqu);
        if (book_huoqu == undefined) {
          Cookies.set('book_huoqu', arr[0].id);
        }

      }).catch((e) => {

      })
      //加载广告
      setTimeout(function () {
        that.common.loadAd(405,that.nav_bottom_id);
      }, 600)
    },
    goBack:function(){
      if(this.src && this.src_id){
        this.$router.push({name:this.src,query:{id:this.src_id}});
      }else if(this.src){
        this.$router.push({name:this.src});
      }else{
        this.$router.push({path:'/meizhuang'});
      }
    },
    refresh:function (){
      this.$router.go(0)
    },
  },
  created() {

  },
  mounted: function () {
    this.getCookie();
    this.initSrc();
    this.userTool.setUserLastRouter(this.name);
    var page = {num: 1, size: 10}
    this.upCallback(page);

    if(this.common.srcFromWeather()){
      this.fromWeather = true;
    }else{
      this.fromWeather = false;
    }
    var _hmt = _hmt || [];
    var hm = document.createElement("script");
    if(this.fromWeather){
      hm.src = "https://hm.baidu.com/hm.js?da9815d6b4a5d97e58c2156c9b3060cf";
    }else{
      hm.src = "https://hm.baidu.com/hm.js?3e969611694dba0a7e1be8513c061efb";
    }
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);

    let that = this;
    setTimeout(function () {
      that.common.loadAd(404,that.nav_id);
    }, 600)

  },
  activated:function (){
    let height = this.userTool.getBHeight()
    if(height && height >= 0){
      $("body").animate({scrollTop: height}, 100);
    }
    this.getCookie();
  },
  deactivated:function (){
    // console.log("list:deactivated");
  },
  watch: {
    huo: function () {

    }

  }
}
</script>

<style scoped>
.cont1 {
  width: 100%;
  height: .36rem;
  line-height: .36rem;
  display: flex;
  justify-content: space-around;
  border: 1px solid #efeeee;
  color: #53575a;
}

a, input {
  -webkit-appearance: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

img {
  pointer-events: none;
}

#header {
  padding: 0 .16rem;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

#header h4 {
  font-weight: bold;
  color: #ba1515;
  line-height: .52rem;
}

#header h3 {
  font-weight: bold;
  color: #ba1515;
  font-size: .14rem;
  line-height: .52rem;
  margin-right: .12rem;
}

#header h3 span {
  font-weight: bold;
  color: #ba1515;
  font-size: .14rem;
  line-height: .52rem;
}

#nav {
  width: 100%;
  background: #f5f5f5;
}

#nav1 {
  width: 100%;
  z-index: 99999;
  position: fixed;
}


.pubu {
  padding: .1rem .1rem 0rem .1rem;
}

.yg img {
  width: 100%;
  /* filter: blur(2px); */
}

.yg p {
  width: 100%;
  font-size: 0.75rem;
  padding: 3px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space:  nowrap;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow:  hidden;
  color: #999;
}

.yg_l, .yg_c, .yg_r {
  width: 1.66rem;
}

.yg li {
  /*height:2.6rem;*/
  /*line-height: 2.5rem;*/
  overflow: hidden;
  /* background: #000; */
  background: #fff;
  margin-bottom: .08rem;
  border-radius: 0.1rem;
}

.yg_l {
  float: left;
}

.yg_c {
  float: left;
  margin-left: .05rem;
}

.yg_r {
  float: right;
}

.u_xinx {
  position: absolute;
  bottom: 4px;
}

.u_xinx img {
  margin-left: 5px;
  background: rgba(0, 0, 0, .2);
  box-shadow: 0 1px 3px rgba(0, 0, 0, .5);
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: inline-block;
}

.u_xinx span {
  position: relative;
  text-shadow: 0 1px 1px #333;
  top: -8px;
  color: #fff;
  font-size: 0.6rem;
}

#foot {
  width: 100%;
  /*height: 1rem;*/
  background: #ba1515;
  color: white;
  font-size: .12rem;
  /* margin: 0 .12rem; */
  margin-left: -.1rem;
  text-align: center;
  padding: .1rem 0;
  line-height: .22rem;
}

#tishi {
  width: 2rem;
  height: .4rem;
  background: #fff;
  position: fixed;
  left: .74rem;
  bottom: .2rem;
  border-radius: .04rem;
  display: flex;
  justify-content: space-around;
  padding: .06rem;
}

/* #logo{
  width: .6rem;
}
#logo img{
  width: 100%;
  height: 100%;
} */
.img-de {
  position: relative;
  margin-top: .1rem;
  top: 83%;
  width: 100%;
  /*padding: 0 .1rem;*/
  height: .3rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: .3rem;
}

#goind {
  width: .2rem;
  height: .2rem;
  background: url(../../static/img/index_icon.png) no-repeat;
  background-size: 100%;
}

#tomin {
  width: .2rem;
  height: .2rem;
  background: url(../../static/img/my_icon.png) no-repeat;
  background-size: 100%;
}


#user {
  width: .2rem;
  height: .2rem;
  background-size: 100%;
  border-radius: .2rem;
  overflow:hidden;
}

#user img {
  vertical-align: initial;
}
#onmore {
  width: 3.2rem;
  margin: 0.1rem auto;
  height: .36rem;
  line-height: .36rem;
  text-align: center;
  color: #999999;
  font-size: .13rem;
  border: 1px solid #ededed;
  border-radius: .04rem;
}

.note-item .note-content .note-title {
  color: #333;
  margin-top: .1rem;
  font-weight: 500;
  font-size: .16rem;
}

.note-nick {
  color: #333;
  font-size: .15rem;
  width: 1.62rem;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: top;
  line-height: .5rem;
  margin-left: 0.1rem;
}




</style>



// WEBPACK FOOTER //
// src/view/BeautyList.vue